import { useAuth } from '../../util/auth';

function ReviewRow({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex flex-col py-2 border-b border-slate-100 last:border-b-0">
      <span className="text-xs text-slate-400">{label}</span>
      <span className="text-sm text-slate-700 whitespace-pre-wrap">{value}</span>
    </div>
  );
}

function AdminApplyStepReview({ orgData, infoData, submitting, submitError, onBack, onSubmit }) {
  const auth = useAuth();

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-slate-700">Review your request</h2>
      <p className="text-sm text-slate-400">
        Please confirm everything below is correct before submitting.
      </p>

      {submitError && <div className="text-xs text-secondary-red">{submitError}</div>}

      <div className="flex flex-col rounded-xl border border-slate-200 px-4">
        <ReviewRow label="Account" value={auth.user.name ? `${auth.user.name} (${auth.user.email})` : auth.user.email} />
        <ReviewRow
          label="Organization"
          value={
            orgData.orgMode === 'existing'
              ? orgData.orgName
              : `${orgData.orgName} (new organization)`
          }
        />
        {orgData.orgMode === 'new' && <ReviewRow label="Organization Bio" value={orgData.orgBio} />}
        <ReviewRow label="Your Name" value={infoData.contactName} />
        <ReviewRow label="Phone Number" value={infoData.contactPhone} />
        <ReviewRow label="Additional Info" value={infoData.additionalInfo} />
        {/* Proof of association file upload — disabled for now, keep for easy re-enable.
        <ReviewRow
          label="Proof of Association"
          value={
            infoData.proofFiles?.length
              ? infoData.proofFiles.map(f => f.name).join(', ')
              : 'None provided'
          }
        />
        */}
      </div>

      <div className="flex justify-end gap-2 mt-2">
        <button
          type="button"
          className="btn btn-outline btn-sm focus:outline-none"
          onClick={onBack}
          disabled={submitting}
        >
          Back
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm focus:outline-none"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? <span className="loading loading-spinner loading-xs" /> : 'Submit Request'}
        </button>
      </div>
    </div>
  );
}

export default AdminApplyStepReview;
